// extracted by mini-css-extract-plugin
module.exports = {"name":"resourceInfo_name_1TK2wqF","timings":"resourceInfo_timings_14hMYgu"};